import React, { useMemo } from 'react'
import {
  Grid, Paper, makeStyles, Theme, createStyles, FormControl, TextField, Button, CircularProgress, FormHelperText, Typography
} from "@material-ui/core";

import { green } from '@material-ui/core/colors';
import { typeputUncontract } from '../../../api/helpline/mikeiyaku';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '80%'
    },
    form: {
      padding: theme.spacing(1),
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%"
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);

interface Prop {
  loading: boolean,
  form: typeputUncontract,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  reqItem: {
    userName: boolean;
    userNameSyllabary: boolean;
  },
  onSubmit: () => void,
}


const UncontractEditForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { loading, form, handleChangeForm, onSubmit, reqItem } = props

  const allCheck = useMemo(() => {
    if (reqItem.userName || reqItem.userNameSyllabary) {
      return true
    } else if (loading) {
      return true
    } else {
      return false
    }
  }, [reqItem, loading])

  return (
    <React.Fragment>
      <Paper>
        <form className={classes.form}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Paper elevation={0} className={classes.paper}>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqItem.userName}>
                  <TextField id="userName" variant="outlined" name="userName" label="会社名" size="small" required value={form.userName} onChange={handleChangeForm} error={reqItem.userName} helperText={'会社名は正式名称を入力してください。(スペース無し)'} />
                  {reqItem.userName && <FormHelperText error>必須項目です</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqItem.userName}>
                  <TextField id="userNameSyllabary" variant="outlined" name="userNameSyllabary" label="会社名カナ" size="small" required value={form.userNameSyllabary} onChange={handleChangeForm} error={reqItem.userNameSyllabary} helperText={'入力例：株式会社シーアイエスの場合、シ'} />
                  {!form.userNameSyllabary && <FormHelperText error>必須項目です</FormHelperText>}
                  {reqItem.userNameSyllabary && <FormHelperText error>全角カタカナの1文字のみです</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="center" direction="column" alignItems="center">
                  <Grid item>
                    <div className={classes.wrapper}>
                      <Button variant="contained" color="primary" size="large"
                        className={classes.button}
                        disabled={allCheck}
                        onClick={onSubmit}>
                        変更
                    </Button>
                      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                  </Grid>
                  <Grid item>
                    {allCheck && !loading && <Typography color='error' variant="caption">{`未入力の必須項目かエラーがあります`}</Typography>}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </form>
      </Paper>
    </React.Fragment>
  )
}

export default UncontractEditForm
